var numberRegex = /^[0-9\b]+$/;
var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
var numericFloatRegex = /^(0|[1-9]\d*)(\.\d+)?$/;
module.exports = {
  numberRegex,
  emailRegex,
  numericFloatRegex,
};
